<template>
  <footer class="footer">
    <div class="grid grid--container">
      <p class="footer__copyright">
        Copyright {{ new Date().getFullYear() }} Campsite.bio
      </p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  border-top: 5px solid var(--g-color-gray-300);
  padding: 1.5rem 0;
  text-align: center;
}
</style>
